import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableInteractiveReloadButton = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableInteractiveReloadButtonOnOrdersGrid);
};
